export default __webpack_public_path__ + "assets/media/girl.b302b069.png";